<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'700px'"
    :classDialog="'createDialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
    :footerVisible="isCanUpdate"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Tạo mới đánh giá nhân viên
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="120px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Nhân sự" prop="userDeptRoleId">
              <el-select
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="form.userDeptRoleId"
                placeholder="Gõ để tìm kiếm"
                size="medium"
                remote
                reserve-keyword
                :remote-method="searchUserDeptRole"
                :loading="isSearchUserDeptRole"
                filterable
                @change="userDeptRoleIdChanged"
              >
                <el-option
                  v-for="item in userDeptRoles"
                  :key="item.id"
                  :label="
                    `${item.fullName} (${item.positionName} - ${item.deptName})`
                  "
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Lý do" prop="rankingReasonId">
              <el-select
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="form.rankingReasonId"
                placeholder="-"
                size="medium"
                filterable
                clearable
                @change="rankingReasonIdChanged"
              >
                <el-option-group
                  v-for="group in rankingReasonGroups"
                  :key="group.value"
                  :label="group.label"
                >
                  <el-option
                    v-for="item in group.rankingReasons"
                    :key="item.id"
                    :label="`(${getTypeLabel(item.type)}) ${item.name}`"
                    :value="item.id"
                  ></el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="Cộng/trừ điểm" prop="type">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.type"
                placeholder="Cộng/trừ điểm"
                size="medium"
                :disabled="!!form.rankingReasonId"
                @change="typeChanged"
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Loại" prop="scoreType">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.scoreType"
                placeholder="Chuyên môn/nguyên tắc"
                size="medium"
                :disabled="!!form.rankingReasonId"
                @change="scoreTypeChanged"
              >
                <el-option
                  v-for="item in scoreTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="Ngày đánh giá" prop="checkDate">
              <el-date-picker
                size="medium"
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="form.checkDate"
                placeholder="dd/mm/yyyy"
                type="date"
                format="dd/MM/yyyy"
                :prefix-icon="' '"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Điểm" prop="score">
              <el-input-number
                class="input-border__bottom input-border__radius__0"
                v-model="form.score"
                size="medium"
                placeholder="Điểm"
                :controls="false"
                :min="-100"
                :step="0.1"
                :precision="1"
                :max="100"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Ghi chú" prop="note">
              <el-input
                v-model="form.note"
                type="textarea"
                placeholder="-"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="5000"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
    <template #footer>
      <div
        class="flex-row form-button__action flex-row-space-between"
        v-if="!!id"
      >
        <div class="flex__left">
          <el-button
            size="medium"
            class="addDocs color__white bg__red btn-none__border"
            @click="delete_"
          >
            <i class="far fa-trash-alt font-size__small"></i>
            &nbsp;Xóa
          </el-button>
        </div>

        <div class="flex__right">
          <el-button
            size="medium"
            type="success"
            class="addDocs  color__white bg__blue btn-none__border"
            @click="save"
          >
            <i class="far fa-check-circle font-size__small"></i>
            &nbsp;Lưu
          </el-button>
          <el-button
            type="info"
            size="medium"
            class="btn__cancel btn-none__border"
            @click="$emit('closeDialog')"
          >Bỏ qua
          </el-button>
        </div>
      </div>
      <div v-else class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="save"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Lưu
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import CustomDialog from "../common/custom-dialog";
import constants from "../../constants";
import rankingUtils from "../../services/rankingUtils";
import Vue from "vue";
import rankingReasonService from "../../services/rankingReasonService";
import errorMessageFilter from "../../filters/errorMessageFilter";
import userDeptRoleViewService from "../../services/userDeptRoleViewService";
import h from "../../services/h";
import rankingScoreService from "../../services/rankingScoreService";
import menuConfigService from "../../services/menuConfigService";

export default {
  name: "ranking-score-create-dialog",
  props: ["isOpen", "id"],
  components: {CustomDialog},
  data() {
    return {
      form: {
        userDeptRoleId: null,
        rankingReasonId: null,
        type: null,
        scoreType: null,
        score: null,
        note: null,
        checkDate: null
      },
      rules: {},
      typeOptions: [],
      scoreTypeOptions: [],
      isSearchUserDeptRole: false,
      userDeptRoles: [],
      rankingReasons: [],
      rankingReasonGroups: [],
      rankingScore: null,
      isCanUpdate: false,
      // deptId: null
    };
  },

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },

    deptId() {
      return this.userDeptRole ? this.userDeptRole.deptId : null;
    },

    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    }
  },

  created() {
    this.initForm();
    this.initOptions();
    this.initValidationRules();
    this.loadAccessRight();

    if (this.id) {
      this.loadRankingScore().then(() => {
        this.initFormForEditing();
        this.loadUserDeptRole();
        this.loadRankingReasons(this.deptId).then(rankingReasons =>
          this.initRankingReasonGroups(rankingReasons)
        );
      });
    } else {
      this.loadRankingReasons(this.deptId).then(rankingReasons =>
        this.initRankingReasonGroups(rankingReasons)
      );
    }
  },

  methods: {

    loadAccessRight() {
      return menuConfigService
        .isEnableMenu(
          this.userDeptRoleId,
          constants.MENU_LIST.CONGVIEC_SCORE_UPDATE
        )
        .then(isEnable => (this.isCanUpdate = isEnable));
    },

    initNote() {
      if (!this.form.rankingReasonId || !this.form.type || !this.form.scoreType)
        return "";

      let rankingReason = h.find(
        this.rankingReasons,
        rankingReason => rankingReason.id === this.form.rankingReasonId
      );
      return `${rankingUtils.getTypeLabel(
        this.form.type
      )} ${rankingUtils.getScoreTypeLabel(this.form.scoreType)} do ${
        rankingReason.name
      }`;
    },

    loadUserDeptRole() {
      return userDeptRoleViewService
        .findById(this.rankingScore.userDeptRoleId)
        .then(response => (this.userDeptRoles = [response.data]));
    },

    loadRankingScore() {
      return rankingScoreService
        .findById(this.id)
        .then(response => (this.rankingScore = response.data));
    },

    initForm() {
      this.form.checkDate = new Date();
    },

    typeChanged() {
      this.form.note = this.initNote();
      this.$refs.form.validateField("note");
    },

    scoreTypeChanged() {
      if (!this.form.note) {
        this.form.note = this.initNote();
        this.$refs.form.validateField("note");
      }
    },

    rankingReasonIdChanged() {
      if (this.form.rankingReasonId) {
        let rankingReason = h.find(
          this.rankingReasons,
          rankingReason_ => rankingReason_.id === this.form.rankingReasonId
        );

        this.form.type = rankingReason.type;
        this.form.scoreType = rankingReason.scoreType;
        this.form.score = rankingReason.defaultScore;
        (!this.form.note) && (this.form.note = this.initNote());

        this.$refs.form.validateField("type");
        this.$refs.form.validateField("scoreType");
        this.$refs.form.validateField("score");
        this.$refs.form.validateField("note");
      }
    },

    getTypeLabel(type) {
      return rankingUtils.getTypeLabel(type);
    },

    userDeptRoleIdChanged() {
      this.$refs.form.validateField("userDeptRoleId");
    },

    loadRankingReasons(deptId) {
      let includeId = this.rankingScore
        ? this.rankingScore.rankingReasonId
        : null;
      return rankingReasonService
        .findAll({
          deptId: deptId,
          includeId: includeId,
          status: constants.STATUS_.ACTIVE
        })
        .then(response => (this.rankingReasons = response.data));
    },

    initRankingReasonGroups() {
      this.rankingReasonGroups = h.collect(
        [
          constants.RANKING_REASON.SCORE_TYPE.CHUYENMON,
          constants.RANKING_REASON.SCORE_TYPE.NGUYENTAC
        ],
        type => {
          return {
            value: type,
            label: rankingUtils.getScoreTypeLabel(type),
            rankingReasons: h.findAll(
              this.rankingReasons,
              rankingReason => rankingReason.scoreType === type
            )
          };
        }
      );
    },

    searchUserDeptRole(query) {
      this.isSearchUserDeptRole = true;
      let includeId = this.rankingScore
        ? this.rankingScore.userDeptRoleId
        : null;
      (query && query.trim()
          ? userDeptRoleViewService
            .findAllForRankingScore(query, includeId)
            .then(response => response.data)
          : Promise.resolve([])
      )
        .then(userDeptRoles => (this.userDeptRoles = userDeptRoles))
        .then(() => (this.isSearchUserDeptRole = false))
        .catch(() => (this.isSearchUserDeptRole = false));
    },

    initFormForEditing() {
      this.form.userDeptRoleId = this.rankingScore.userDeptRoleId;
      this.form.rankingReasonId = this.rankingScore.rankingReasonId;
      this.form.type = this.rankingScore.type;
      this.form.scoreType = this.rankingScore.scoreType;
      this.form.score = this.rankingScore.score;
      this.form.note = this.rankingScore.note;
      this.form.checkDate = new Date(this.rankingScore.checkDate);
    },

    initValidationRules() {
      let defaultRequiredConstrains = {
        required: true,
        message: "Trường dữ liệu bắt buộc",
        trigger: "blur"
      };

      Vue.set(this.rules, "userDeptRoleId", [defaultRequiredConstrains]);
      Vue.set(this.rules, "type", [defaultRequiredConstrains]);
      Vue.set(this.rules, "scoreType", [defaultRequiredConstrains]);
      Vue.set(this.rules, "score", [defaultRequiredConstrains]);
      Vue.set(this.rules, "checkDate", [defaultRequiredConstrains]);
      Vue.set(this.rules, "note", [defaultRequiredConstrains]);
    },

    initOptions() {
      this.typeOptions = rankingUtils.initTypeOptions();
      this.scoreTypeOptions = rankingUtils.initScoreTypeOptions();
    },

    validateForm() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (!valid) return;
          resolve();
        });
      });
    },

    save() {
      this.validateForm()
        .then(() => (this.id ? this.update_() : this.save_()))
        .then(rankingReason => {
          this.$message({
            message: this.id
              ? errorMessageFilter({errorCode: "rankingScore.update.success"})
              : errorMessageFilter({
                errorCode: "rankingScore.insert.success"
              }),
            type: "success"
          });
          this.id
            ? this.$emit("updateSuccess", {result: rankingReason})
            : this.$emit("insertSuccess", {result: rankingReason});
        })
        .catch(error => {
          this.commonHandleRequestError(error);
          throw error;
        });
    },

    convertToSubmitForm() {
      return {
        userDeptRoleId: this.form.userDeptRoleId,
        rankingReasonId: this.form.rankingReasonId,
        type: this.form.type,
        scoreType: this.form.scoreType,
        score: this.form.score,
        note: this.form.note,
        checkDate: this.form.checkDate.getTime()
      };
    },

    save_() {
      console.log(JSON.stringify(this.convertToSubmitForm()));
      return rankingScoreService
        .insert(this.convertToSubmitForm())
        .then(response => response.data);
    },

    delete_() {
      return this.$confirm(
        errorMessageFilter({
          errorCode: "rankingScore.delete.confirm"
        }),
        {
          confirmButtonText: "Xác nhận",
          cancelButtonText: "Bỏ qua",
          type: "warning"
        }
      )
        .then(() => rankingScoreService.delete(this.id))
        .then(response => {
          this.$message({
            message: errorMessageFilter({
              errorCode: "rankingScore.delete.success"
            }),
            type: "success"
          });
          this.$emit("deleteSuccess", {result: response.data});
        });
    },

    update_() {
      return rankingScoreService
        .update(this.id, this.convertToSubmitForm())
        .then(response => response.data);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/ranking-score/ranking-score-create-dialog.vue